import "./styles.css";
import React from "react";
import Context from "./context";
import app from "./data/app";
import Draggable from "react-draggable";

import Taskbar from "./component/taskbar";
import Chrome from "./apps/chrome";
import Calculator from "./apps/calculator";
import Alarm from "./apps/alarm";
import Sublime from "./apps/sublime";
import Setting from "./apps/setting";

function Authentication() {
  const cont = React.useContext(Context);
  const [ituser, setituser] = React.useState(false);
  const [user, setuser] = React.useState("");
  const [pw, setpw] = React.useState("");
  function register(e) {
    e.preventDefault();
    localStorage.setItem(
      "user",
      JSON.stringify({
        name: user,
        password: btoa(pw + ';System.out.println("ferdiansyah0611")')
      })
    );
    setuser("");
    setpw("");
    setituser(true);
    cont.set().setState({ user: { name: user, pw: pw } });
  }
  function login(e) {
    e.preventDefault();
    var check = JSON.parse(localStorage.getItem("user"));
    if (
      btoa(pw + ';System.out.println("ferdiansyah0611")') === check.password
    ) {
      cont.set().setState({ user: { name: check.name, pw: check.password } });
      setituser(true);
    }
  }
  return (
    <div
      className={
        ituser
          ? "fixed left-0 top-0 h-screen bg-black w-full z-50 bg-opacity-50 transform duration-500 scale-0"
          : "fixed left-0 top-0 h-screen bg-black w-full z-50 bg-opacity-50 transform duration-500 scale-100"
      }
    >
      <div className="flex mx-auto mt-20">
        <div className="w-full flex flex-wrap justify-center">
          <div className="w-full flex justify-center">
            <div className="rounded-full w-20 h-20 text-center border">
              <i className="fas fa-user text-white mt-4 text-4xl" />
            </div>
          </div>
          {localStorage.getItem("user") ? (
            <div className="flex flex-wrap justify-center text-center">
              <p className="text-white my-4 w-full text-xl">
                {JSON.parse(localStorage.getItem("user")).name}
              </p>
              <form onSubmit={login} className="w-full">
                <input
                  className="p-1 focus:outline-none"
                  type="password"
                  placeholder="Password"
                  onKeyUp={(e) => setpw(e.target.value)}
                />
                <div className="flex justify-center">
                  <button
                    className="p-2 bg-blue-800 text-white mt-2 focus:outline-none"
                    onClick={(e) => login(e)}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          ) : (
            <div className="flex flex-wrap justify-center text-center">
              <p className="text-white my-4 w-full text-xl">Registration</p>
              <form onSubmit={(e) => register(e)} className="w-full">
                <div className="flex justify-center">
                  <input
                    className="p-1 focus:outline-none"
                    type="text"
                    placeholder="Username"
                    onKeyUp={(e) => setuser(e.target.value)}
                  />
                </div>
                <div className="flex justify-center mt-2 focus:outline-none">
                  <input
                    className="p-1 focus:outline-none"
                    type="password"
                    placeholder="Password"
                    onKeyUp={(e) => setpw(e.target.value)}
                  />
                </div>
                <button
                  className="p-2 bg-blue-800 text-white mt-2"
                  onClick={(e) => register(e)}
                >
                  Submit
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openApp: [],
      openStart: false,
      openSearch: false,
      openNotification: false,
      app: app,
      set: () => {
        return this;
      },
      users: {},
      theme: "dark"
    };
  }
  componentDidMount() {
    if (!localStorage.getItem("alarm")) {
      localStorage.setItem("alarm", JSON.stringify([]));
    }
  }
  render() {
    return (
      <Context.Provider value={this.state}>
        <div id="body">
          <Authentication />
          <div className="flex flex-wrap p-2 text-white">
            <Draggable>
              <div className="flex flex-wrap justify-center text-xs hover:bg-gray-400 cursor-pointer p-2">
                Recycle Bin
              </div>
            </Draggable>
            <Draggable>
              <div className="flex flex-wrap justify-center text-xs hover:bg-gray-400 cursor-pointer p-2">
                File Manager
              </div>
            </Draggable>
          </div>
          <div className="flex flex-wrap justify-center fixed left-0 top-0 w-full">
            {this.state.openApp.filter((d) => d === "Chrome").length ? (
              <Chrome open={true} />
            ) : (
              false
            )}
          </div>
          <div className="flex flex-wrap justify-center fixed left-0 top-0 w-full">
            {this.state.openApp.filter((d) => d === "Calculator").length ? (
              <Calculator open={true} />
            ) : (
              false
            )}
          </div>
          <div className="flex flex-wrap justify-center fixed left-0 top-0 w-full">
            {this.state.openApp.filter((d) => d === "Alarm").length ? (
              <Alarm open={true} />
            ) : (
              false
            )}
          </div>
          <div className="flex flex-wrap justify-center fixed left-0 top-0 w-full">
            {this.state.openApp.filter((d) => d === "Sublime Text 3").length ? (
              <Sublime open={true} />
            ) : (
              false
            )}
          </div>
          <div className="flex flex-wrap justify-center fixed left-0 top-0 w-full">
            {this.state.openApp.filter((d) => d === "Setting").length ? (
              <Setting open={true} />
            ) : (
              false
            )}
          </div>
        </div>
        <Taskbar />
      </Context.Provider>
    );
  }
}

export default App;
